// This file is auto-generated
/* eslint-disable */
import deDE from './quellede/de-DE.json';
const messages = { 'de-DE': deDE };
export default messages;